//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { ExperienceContainerType } from '@models/ExperienceContainerType';
import { Opaque } from '@utils/opaque';

/**
 * Identifiers a gallery container uniquely within a client.
 *
 * Known values are 'homepage', 'product', and, 'category'.
 * Otherwise, this is an arbitrary uuid.
 *
 * Maps to GalleryContainerName in curalate-web-gateway.
 */
type GalleryContainerId<T extends string = string> = Opaque<
  T,
  'GalleryContainerId'
>;

function GalleryContainerIdFactory(galleryId: string) {
  return galleryId as GalleryContainerId;
}

function specific<T extends string>(galleryId: T) {
  return galleryId as GalleryContainerId<T>;
}

const GalleryContainerId = Object.assign(GalleryContainerIdFactory, {
  Homepage: specific(ExperienceContainerType.HOMEPAGE),
  Product: specific(ExperienceContainerType.PRODUCT),
  Category: specific(ExperienceContainerType.CATEGORY),
  InstaShop: specific(ExperienceContainerType.INSTASHOP),
});

export type GalleryContainerTypes =
  | ExperienceContainerType.HOMEPAGE
  | ExperienceContainerType.PRODUCT
  | ExperienceContainerType.CATEGORY
  | ExperienceContainerType.INSTASHOP;

export default GalleryContainerId;
